import i18n, { i18nInit } from '@analyzer/i18n/i18n'
import { router } from '@analyzer/router'
import { ROUTES } from '@analyzer/utils/router/paths'
import { consumeAuthFromHash } from '@core/utils/auth-from-hash'
import { startApp } from '@core/utils/start-app'

import '@analyzer/index.css'
import { initAppName } from '@design/utils/appName'

consumeAuthFromHash()
initAppName()

startApp({
  router,
  i18n,
  i18nInit,
  sentryDsn: import.meta.env.VITE_ANALYSER_SENTRY_DSN,
  logOutPath: ROUTES.logOut,
  themeStorageKey: 'analyzer-ui-theme',
})
